module.exports = "<p>empty works!</p>\n"